<template>
    <div>
        <h1>
            Authorized Users
        </h1>
    <b-row>
    <b-table hover small responsive show-empty class="sr-caption"
             aria-live="polite"
             :fields="fields"
             :items="providerUsers"
             primary-key="id"
             :busy="isLoading"
             label-sort-asc=""
             label-sort-desc=""
    >
        <template v-slot:cell(actions)="row">
            <b-button size="sm"
                      variant="primary"
                      class="mr-1"
                      @click="showStatusModal(row)"
                      target="_attach"
            >
                Change status
            </b-button>
        </template>
        <template v-slot:empty="scope">
            <p>No authorized users found for this facility</p>
        </template>
        <template v-slot:cell(enabled)="row">
            {{row.item.enabled?'Active':'Inactive'}}
        </template>
        <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                       label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
            <strong>Loading, Please Wait...</strong>
        </div>
    </b-table>
    </b-row>
    <b-row>
        <b-col>
            <b-button variant="primary" @click="showAddUserForm=true">Add new user</b-button>
        </b-col>
    </b-row>
        <br/><br/>
        <div v-if="showAddUserForm">
            <b-row>
                <b-col cols="4">
                    <BaseTextInput v-model="newUser.email"
                                   :v="$v.newUser.email"
                                   label="User Email"
                                   slug="email"/>
                </b-col>
                <b-col cols="4">
                    <BaseTextInput v-model="newUser.firstName"
                                   :v="$v.newUser.firstName"
                                   label="First Name"
                                   slug="firstName"/>
                </b-col>
                <b-col cols="4">
                    <BaseTextInput v-model="newUser.lastName"
                                   :v="$v.newUser.lastName"
                                   label="Last Name"
                                   slug="lastName"/>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button variant="primary" @click="showAddUserModal">Add user</b-button>
                    <b-button variant="secondary" @click="showAddUserForm=false">Cancel</b-button>
                </b-col>
            </b-row>
        </div>


        <b-modal id="statusModal" hide-header hide-footer>
            <h2>Change {{currentUser.firstName}} {{currentUser.lastName}}'s active status?</h2>
            <p>Current status: {{currentUser.enabled ? "Active" : "Inactive"}}</p>
            <div>
                <b-button variant="primary" @click="changeStatus">Make {{currentUser.enabled ? "Inactive" : "Active"}}</b-button>
                <b-button variant="secondary" @click="hideStatusModal">Cancel</b-button>
            </div>
        </b-modal>

        <b-modal id="addUserModal" hide-header hide-footer>
            <h2>Add new authorized user?</h2>
            <p>You are about to add new user {{newUser.firstName}} {{newUser.lastName}} with email address {{newUser.email}} to the list of authorized users of this facility.</p>
            <p>Press confirm to add the user or cancel to return.</p>
            <div>
                <b-button variant="primary" @click="addNewUser">Confirm</b-button>
                <b-button variant="secondary" @click="hideAddUserModal()">Cancel</b-button>
            </div>
        </b-modal>

    </div>
</template>

<script>

    import axios from 'axios';
    import BaseTextInput from "@/components/templates/input/BaseTextInput";
    import {required, email} from 'vuelidate/lib/validators';
    import {toastService} from "@/mixins/toastService";


    export default {
        name: "AuthorizedUsers.vue",
        components:{
            BaseTextInput
        },
        mixins: [
            toastService
        ],
        data:()=>({
            providerUsers: [],
            fields:[
                {key: 'lastName', label: 'Last Name', sortable: true},
                {key: 'firstName', label: 'First Name', sortable: true},
                {key: 'email', label: 'Email', sortable: true},
                {key: 'enabled', label:'Status',sortable:true},
                {key: 'actions', label: 'Change status'}
            ],
            currentUser: {
                idmId: null,
                firstName: null,
                lastName: null,
                email: null,
                enabled: null
            },
            showAddUserForm: false,
            newUser: {
                email: null,
                firstName: null,
                lastName: null,
                idmId: null,
                enabled: null
            },
            isLoading: false
        }),
        validations:{
            newUser: {
                email: {
                    required,
                    email
                },
                firstName:{
                    required
                },
                lastName: {
                    required
                }
            }
        },
        created(){
            this.loadProviderUsers();
        },
        methods:{
            loadProviderUsers(){
                this.isLoading = true;
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/provider/users/get`)
                    .then(response => {
                        this.providerUsers = response.data;
                    })
                    .catch(error=>{
                        toastService.showRootToast('Error', 'Issue loading current provider users','danger', this.$root);
                    })
                    .finally(()=>{
                        this.isLoading=false;
                    })
            },
            changeStatus(status){
                axios.put(`${process.env.VUE_APP_API_BASE_URL}/provider/users/changeStatus`, this.currentUser.idmId)
                    .then(response=>{
                        this.loadProviderUsers();
                    })
                    .catch(error=>{
                        if(error.response.status===409){
                          this.showRootToast('Error','Setting this user as active would exceed your limit of 3 active users. Set a user to inactive before proceeding.','danger')
                        }
                        else {
                          this.showRootToast('Error', 'Issue changing user\'s status', 'danger', this.$root);
                        }
                    })
                    .finally(()=>{
                        this.hideStatusModal();
                    })
            },
            showStatusModal(row){
                this.currentUser = row.item;
                this.$bvModal.show('statusModal');
            },
            hideStatusModal(){
                this.currentUser = {
                    idmId: null,
                    firstName: null,
                    lastName: null,
                    email: null,
                    status: null
                };
                this.$bvModal.hide('statusModal');
            },
            addNewUser(){
                this.$v.$touch();
                if(this.$v.$invalid){
                    return;
                }
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/provider/users/add`, this.newUser)
                    .then(response=>{
                        this.showRootToast('User added', 'Successfully added user','success', this.$root);
                        this.showAddUserForm = false;
                        this.newUser = {
                            email: null,
                            firstName: null,
                            lastName: null,
                            idmId: null,
                            active: null
                        };
                        this.loadProviderUsers();
                    })
                    .catch(error=>{
                        if(error.response.status===406){
                            this.showRootToast('Error adding user', 'A user already exists with this email address with a role assigned to it. Please provide a different email address.','danger');
                        }
                        if(error.response.status===409){
                            this.showRootToast('Error adding user', 'Adding this user would exceed your maximum of 3 active users. Set one of the current users to inactive before proceeding.','danger')
                        }
                        else{
                            this.showRootToast('Error', 'Adding user failed', 'danger', this.$root)
                        }

                    })
                    .finally(()=>{
                        this.hideAddUserModal();
                    })
            },
            showAddUserModal(){
                this.$bvModal.show('addUserModal');
            },
            hideAddUserModal(){
                this.$bvModal.hide('addUserModal');
            },
          showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
              title: title,
              toaster: 'b-toaster-top-center',
              solid: true,
              variant: type,
              appendToast: true,
              noAutoHide:true
            })
            this.toastFocus()
          },
          toastFocus() {
            setTimeout(() => {
              let elem = document.getElementsByClassName("toast")
              elem = elem[elem.length-1]
              elem.focus()
            }, 100)
          },
        }
    }
</script>

<style scoped>

</style>